import React from "react";
const parentStyle: React.CSSProperties = {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    zIndex: -1,
    visibility: 'hidden',
};

const shrinkChildStyle: React.CSSProperties = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '200%',
    height: '200%',
};

const expandChildStyle: React.CSSProperties = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
};

export class ResizeDetector extends React.Component<any, any> {
    private expand: any;
    private shrink: any;
    private container: any;

    constructor(props) {
        super(props);

        this.state = {
            expandChildHeight: 0,
            expandChildWidth: 0,
            expandScrollLeft: 0,
            expandScrollTop: 0,
            shrinkScrollTop: 0,
            shrinkScrollLeft: 0,
            lastWidth: 0,
            lastHeight: 0,
        };
    }

    componentDidMount() {
        const [width, height] = this.containerSize();
        this.reset(width, height);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props !== nextProps || this.state !== nextState;
    }

    componentDidUpdate() {
        this.expand.scrollLeft = this.expand.scrollWidth;
        this.expand.scrollTop = this.expand.scrollHeight;

        this.shrink.scrollLeft = this.shrink.scrollWidth;
        this.shrink.scrollTop = this.shrink.scrollHeight;
    }

    containerSize() {
        return [
            this.props.handleWidth && this.container.parentElement.offsetWidth,
            this.props.handleHeight && this.container.parentElement.offsetHeight,
        ];
    }

    reset = (containerWidth, containerHeight) => {
        if (typeof window === 'undefined') {
            return;
        }

        const parent = this.container.parentElement;

        let position = 'static';
        if (parent.currentStyle) {
            position = parent.currentStyle.position;
        } else if (window.getComputedStyle) {
            position = window.getComputedStyle(parent).position;
        }
        if (position === 'static') {
            parent.style.position = 'relative';
        }

        this.setState({
            expandChildHeight: this.expand.offsetHeight + 10,
            expandChildWidth: this.expand.offsetWidth + 10,
            lastWidth: containerWidth,
            lastHeight: containerHeight,
        });
    }

    handleScroll = () => {
        if (typeof window === 'undefined') {
            return;
        }

        const { state } = this;

        const [width, height] = this.containerSize();
        if ((width !== state.lastWidth) || (height !== state.lastHeight)) {
            this.props.onResize(width, height);
        }

        this.reset(width, height);
    }

    render() {
        const { state } = this;

        const expandStyle = $.extend({}, expandChildStyle, {
            width: state.expandChildWidth,
            height: state.expandChildHeight,
        });

        return (
            <div style={parentStyle} ref={(e) => { this.container = e; }}>
                <div style={parentStyle} onScroll={this.handleScroll} ref={(e) => { this.expand = e; }}>
                    <div style={expandStyle} />
                </div>
                <div style={parentStyle} onScroll={this.handleScroll} ref={(e) => { this.shrink = e; }}>
                    <div style={shrinkChildStyle} />
                </div>
            </div>
        );
    }
}